export const isMobileIos = () => {
  return (
    typeof navigator !== 'undefined' &&
    (/iPad|iPhone|iPod/.test(navigator.userAgent || '') ||
      (navigator.userAgent.includes('Macintosh') &&
        navigator.maxTouchPoints > 1))
  );
};
